<template>
  <button
    class="languagesTrigger flex h-max w-max items-center justify-between gap-x-1.5 rounded-sm px-2 py-1.5 text-sm font-normal capitalize text-[#2B2D32] dark:text-white sm:text-xl md:py-2"
    type="button"
    translate="no"
  >
    <GlobeIcon />
    <span class="currentLanguage"></span>
    <ArrowDownIcon />
  </button>
  <div
    class="languages z-10 flex hidden w-14 flex-col rounded-xl bg-[#D4DFD4] text-sm/normal font-normal text-[#2B2D32] *:py-1 *:capitalize dark:bg-[#292A2D] dark:text-[#878787]"
    translate="no"
  ></div>
</template>

<script setup>
import GlobeIcon from '@/components/ui/icons/GlobeIcon.vue'
import ArrowDownIcon from '@/components/ui/icons/ArrowDownIcon.vue'
</script>

<style scoped></style>
